export interface Reason {
  label: string;
  value: string;
}

export interface ReasonListProps {
  name: string;
  reasonList: Reason[];
  showComment?: boolean;
  onSelectionChange?: (value: Reason) => void;
}
